import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntTextClampPipe} from "./int-text-clamp.pipe";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntTextClampPipe
  ],
  exports: [
    IntTextClampPipe
  ]
})
export class IntTextClampModule {}
